// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  
  .chatbot-hidden {        /* applied when the window is collapsed */
    display:none !important;
  }

  .chatbot-wrapper.minimized      {                 /* collapsed look */
  width : 52px;  height : 52px;  border-radius:50%;
  position:fixed; right:30px; bottom:30px;
  overflow:hidden; cursor:pointer;
  box-shadow:0 0 6px rgba(0,0,0,.25);
}

.chatbot-wrapper.minimized .react-chatbot-kit-chat-container {
  display:none !important;                       /* ← hides the UI */
}
    
  .chatbot-wrapper {
    position: fixed;
    right: 0;
    bottom: 0;
    z-index: 9999;
    height: 80%;
    width: 30%;
    margin: 15px;
    border-radius: 5px;
  }

/* on phones: take the full page */
@media (max-width: 768px){
  .chatbot-wrapper{
    left:0;
    right:0;
    top:0;
    bottom:0;
    width:100%;
    height:100%;
    margin:0;
    border-radius:0;
  }
}


  .react-chatbot-kit-chat-container {
    position: fixed;
    right: 5px;
    bottom: 5px;
    z-index: 1200;
    height: 80%;
    width: 30%;
    border-style: solid;
    border-width: 0px;
    border-color: transparent;
    margin: 15px;
    border-radius: 5px;
    box-shadow: 0 4px 4px 0 rgba(30,30,30,0.65), 0 2px 4px 0 rgba(0,0,0,0.25);
  }

  .react-chatbot-kit-chat-container {
      transition: height 0.4s cubic-bezier(0.4, 0, 0.2, 1), 
                  width 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      /* Optionally, add 'overflow: hidden;' to avoid visual glitches */
  }

@media (max-width: 768px){
  .react-chatbot-kit-chat-container{
    position: fixed;   /* keep it fixed so header stays at top */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100% !important;
    height: 100% !important;
    margin: 0;         /* no side gaps */
    border-radius: 0;  /* square corners like the wrapper */
  }
}

  .react-chatbot-kit-chat-inner-container {
    border-radius: 5px;
    height: 100%;
  }

  .react-chatbot-kit-chat-message-container.moved-to-bottom {
     height: 75% !important;
  }

  .react-chatbot-kit-chat-message-container {
    border-radius: 5px;
    height: 100%;
    padding: 0 25.5px 10px 25.5px !important;
  }




  /* Force all chat messages to align left */
.react-chatbot-kit-chat-message-container {
  justify-content: flex-start !important;
}

/* Also remove right margins and force bubble positioning */
.react-chatbot-kit-chat-bot-message {
  margin-left: 0 !important;
  margin-right: auto !important;
  /* Optionally, make all user bubbles look like bot bubbles: */
  background-color: #fff !important;   /* Set your preferred bubble color */
  color: #000 !important;              /* Set your preferred text color */
}

.react-chatbot-kit-user-chat-message {
  margin-left: 0 !important;
  xmargin-right: auto !important;
  /* Optionally, make all user bubbles look like bot bubbles: */
  background-color: #91DDCA88 !important;   /* Set your preferred bubble color */
  color: black !important;              /* Set your preferred text color */
  border-radius: 10px;

}

.react-chatbot-kit-chat-bot-message-arrow {
  display: none !important;
}

.react-chatbot-kit-user-chat-message-arrow {
  display: none !important;
}


.react-chatbot-kit-chat-bot-message {
    width: 100%;
    text-align: left;
    font-size: 1.1em;
}

.react-chatbot-kit-chat-user-message {
    width: 100%;
    text-align: center;
    background-color: lightgray !important;
    border-radius: 5px;
}


.react-chatbot-kit-chat-btn-send {
  background-color: transparent !important;
  height: 0;
  width: 0;
  display: none;

}

.react-chatbot-kit-chat-input-container {
  
   top: clamp(120px, 12%, 45%);
  bottom: auto;
  height: 95px;
  width: 94%;
  left: 3%;
  text-align: center;
  background-color: #efecec !important;
  border-radius: 10px;
  border: 1px lightgray solid;
  transition: top 0.4s, bottom 0.4s; /* Optional for smooth movement */
  padding-right: 52px;          /* room for the arrow  */
  box-sizing: border-box;       /* <— THIS line        */
}




.react-chatbot-kit-chat-input {
  background-color: #efecec !important;
  height: 65px;
  border-radius: 5px;
  font-family: Roboto !important;
  border: 0px !important;
  resize: none;
  outline: none !important; /* add this */
  box-shadow: none !important; /* add this */
  padding: 0px;
  padding-left: 15px !important;
  padding-right: 15px !important;
  padding-top: 0px !important;
  font-size: 1.1em !important;
}

.react-chatbot-kit-chat-input:focus {
  outline: none !important;
  box-shadow: none !important;
  border-color: transparent !important;
}

.react-chatbot-kit-file-icon {
  display: none !important;
}

.microphone-audio-wrapper {
  background-color: transparent !important;
  display: none;
}

.react-chatbot-kit-chat-input-form {
  border-top: 0px !important;
}

/* green arrow – always inside the row */
.chatbot-send-button{
  position: fixed;             
  color: #00A887;
  cursor: pointer;
  right : calc(3% + 12px) !important; 
   bottom:auto;
  visibility:hidden;     
  z-index: 10001;  
}


.chatbot-mic-button {
  display: none !important;
}

.chatbot-mic-button.moved-to-bottom {
  top: auto !important;
  bottom: 40px !important; /* Or 0; */
}

.react-chatbot-kit-user-avatar-container {
  display: none !important;  
}

/* element that wraps the HTML coming from the bot */
.custom-html-message {
  transform   : translateY(15px);
  animation   : fadeInUp .5s forwards;
  line-height : .51;                  /* default text line-height  */
}

/* ---- unordered & ordered lists ----------------------------------- */
.custom-html-message ul,
.custom-html-message ol {
  /* A bit of air before the first bullet/number */
  margin-top   : 0em;               /* ← space ABOVE the list    */
  margin-bottom: 0em;               /*   space BELOW (optional)  */
  margin-left  : 1.2em;               /* indent the whole list     */
  padding-left : 0;                   /* keep bullets aligned      */
}

.custom-html-message ul  { list-style: disc    outside; }
.custom-html-message ol  { list-style: decimal outside; }

/* ---- individual list items --------------------------------------- */
.custom-html-message li {
  margin-top   : 0em;              /* vertical spacing BETWEEN bullets */
  margin-bottom: 0em;              /* (adjust to taste)                */
}
/* tighter vertical space after explicit <br> tags */
.custom-html-message br {
  line-height : 0.2em;      /* 40 % of a normal line  – tweak to taste */
  /* you can also use margin if you prefer */
   margin-top : -0.3em;   margin-bottom : 0.3em; 
}


.react-chatbot-kit-chat-input-container.moved-to-bottom {
  top: auto !important;
  bottom: 5% !important; /* Or 0; */
}

.chatbot-send-button.moved-to-bottom {
  //bottom: 40px !important;
    right : calc(3% ) !important; 
   position:fixed !important;   /* switch from absolute → fixed   */
    bottom: calc(5% + 15px)  !important;      /* 20 px up from the bottom edge  */
    top   :auto   !important;     /* neutralise any inline “top:”   */
    left  :auto   !important;     /* neutralise any inline “left:”  */
    z-index:10002;               /* keep it above the chat window  */
}

/* phones: attach the green arrow to the SCREEN, not the wrapper */
@media (max-width:768px){
  .chatbot-send-button.moved-to-bottom{
    position:fixed !important;   /* switch from absolute → fixed   */
    bottom:55px  !important;      /* 20 px up from the bottom edge  */
    right :30px  !important;      /* (tweak if you want 12 px etc.) */
    top   :auto   !important;     /* neutralise any inline “top:”   */
    left  :auto   !important;     /* neutralise any inline “left:”  */
    z-index:10002;               /* keep it above the chat window  */
  }
}


/* helper line at the very bottom, centre-aligned, light grey */
.chatbot-reset-hint{
  position:absolute;          /* relative to .chatbot-wrapper      */
  bottom:5px;                 /* 4 px above the wrapper’s bottom   */
  left:0;
  width:100%;
  text-align:center;
  font-size:14px;
  font-style: italic;
  color:#9e9e9e;              /* light grey                        */
  pointer-events:none;        /* clicks pass through               */
  z-index: 10002
}

.chatbot-reset-hint-small{
  position:absolute;          /* relative to .chatbot-wrapper      */
  bottom:7px;                 /* 4 px above the wrapper’s bottom   */
  left:0;
  width:100%;
  text-align:center;
  font-size:12px;
  font-style: italic;
  color:#9e9e9e;              /* light grey                        */
  pointer-events:none;        /* clicks pass through               */
  z-index: 10002
}

@media (max-width:768px){
    .chatbot-reset-hint-small{
    position:fixed;          /* relative to .chatbot-wrapper      */
    bottom:0px;                 /* 4 px above the wrapper’s bottom   */
    left:0;
    width:100%;
    text-align:center;
    font-size:12px;
    font-style: italic;
    color:#9e9e9e;              /* light grey                        */
    pointer-events:none;        /* clicks pass through               */
    z-index: 10002
  } 
}`, "",{"version":3,"sources":["webpack://./src/components/chatbot/custom.css"],"names":[],"mappings":";EACE,yBAAyB,yCAAyC;IAChE,uBAAuB;EACzB;;EAEA,kDAAkD,mBAAmB;EACrE,YAAY,GAAG,aAAa,GAAG,iBAAiB;EAChD,cAAc,EAAE,UAAU,EAAE,WAAW;EACvC,eAAe,EAAE,cAAc;EAC/B,kCAAkC;AACpC;;AAEA;EACE,uBAAuB,wBAAwB,mBAAmB;AACpE;;EAEE;IACE,eAAe;IACf,QAAQ;IACR,SAAS;IACT,aAAa;IACb,WAAW;IACX,UAAU;IACV,YAAY;IACZ,kBAAkB;EACpB;;AAEF,kCAAkC;AAClC;EACE;IACE,MAAM;IACN,OAAO;IACP,KAAK;IACL,QAAQ;IACR,UAAU;IACV,WAAW;IACX,QAAQ;IACR,eAAe;EACjB;AACF;;;EAGE;IACE,eAAe;IACf,UAAU;IACV,WAAW;IACX,aAAa;IACb,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,yEAAyE;EAC3E;;EAEA;MACI;yDACmD;MACnD,iEAAiE;EACrE;;AAEF;EACE;IACE,eAAe,IAAI,yCAAyC;IAC5D,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,uBAAuB;IACvB,SAAS,UAAU,iBAAiB;IACpC,gBAAgB,GAAG,oCAAoC;EACzD;AACF;;EAEE;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;KACG,sBAAsB;EACzB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,wCAAwC;EAC1C;;;;;EAKA,0CAA0C;AAC5C;EACE,sCAAsC;AACxC;;AAEA,2DAA2D;AAC3D;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,6DAA6D;EAC7D,iCAAiC,IAAI,oCAAoC;EACzE,sBAAsB,eAAe,kCAAkC;AACzE;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,6DAA6D;EAC7D,sCAAsC,IAAI,oCAAoC;EAC9E,uBAAuB,eAAe,kCAAkC;EACxE,mBAAmB;;AAErB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;;AAGA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,sCAAsC;IACtC,kBAAkB;AACtB;;;AAGA;EACE,wCAAwC;EACxC,SAAS;EACT,QAAQ;EACR,aAAa;;AAEf;;AAEA;;GAEG,2BAA2B;EAC5B,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;EACnB,2BAA2B;EAC3B,iCAAiC,EAAE,iCAAiC;EACpE,mBAAmB,WAAW,wBAAwB;EACtD,sBAAsB,QAAQ,wBAAwB;AACxD;;;;;AAKA;EACE,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,sBAAsB;EACtB,YAAY;EACZ,wBAAwB,EAAE,aAAa;EACvC,2BAA2B,EAAE,aAAa;EAC1C,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kCAAkC;GACjC,WAAW;EACZ,iBAAiB;EACjB,cAAc;AAChB;;;AAGA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,uBAAuB,EAAE,UAAU;AACrC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,oDAAoD;AACpD;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,iBAAiB,mBAAmB,8BAA8B;AACpE;;AAEA,uEAAuE;AACvE;;EAEE,gDAAgD;EAChD,kBAAkB,gBAAgB,8BAA8B;EAChE,kBAAkB,gBAAgB,8BAA8B;EAChE,oBAAoB,gBAAgB,8BAA8B;EAClE,gBAAgB,oBAAoB,8BAA8B;AACpE;;AAEA,2BAA2B,2BAA2B,EAAE;AACxD,2BAA2B,2BAA2B,EAAE;;AAExD,uEAAuE;AACvE;EACE,kBAAkB,eAAe,qCAAqC;EACtE,kBAAkB,eAAe,qCAAqC;AACxE;AACA,oDAAoD;AACpD;EACE,mBAAmB,OAAO,4CAA4C;EACtE,0CAA0C;GACzC,mBAAmB,IAAI,qBAAqB;AAC/C;;;AAGA;EACE,oBAAoB;EACpB,qBAAqB,EAAE,UAAU;AACnC;;AAEA;EACE,yBAAyB;IACvB,4BAA4B;GAC7B,yBAAyB,IAAI,mCAAmC;IAC/D,mCAAmC,OAAO,mCAAmC;IAC7E,wBAAwB,MAAM,mCAAmC;IACjE,wBAAwB,MAAM,mCAAmC;IACjE,aAAa,gBAAgB,mCAAmC;AACpE;;AAEA,kEAAkE;AAClE;EACE;IACE,yBAAyB,IAAI,mCAAmC;IAChE,uBAAuB,OAAO,mCAAmC;IACjE,uBAAuB,OAAO,mCAAmC;IACjE,wBAAwB,MAAM,mCAAmC;IACjE,wBAAwB,MAAM,mCAAmC;IACjE,aAAa,gBAAgB,mCAAmC;EAClE;AACF;;;AAGA,+DAA+D;AAC/D;EACE,iBAAiB,WAAW,sCAAsC;EAClE,UAAU,kBAAkB,sCAAsC;EAClE,MAAM;EACN,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa,eAAe,sCAAsC;EAClE,mBAAmB,SAAS,sCAAsC;EAClE;AACF;;AAEA;EACE,iBAAiB,WAAW,sCAAsC;EAClE,UAAU,kBAAkB,sCAAsC;EAClE,MAAM;EACN,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa,eAAe,sCAAsC;EAClE,mBAAmB,SAAS,sCAAsC;EAClE;AACF;;AAEA;IACI;IACA,cAAc,WAAW,sCAAsC;IAC/D,UAAU,kBAAkB,sCAAsC;IAClE,MAAM;IACN,UAAU;IACV,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,aAAa,eAAe,sCAAsC;IAClE,mBAAmB,SAAS,sCAAsC;IAClE;EACF;AACF","sourcesContent":["  \n  .chatbot-hidden {        /* applied when the window is collapsed */\n    display:none !important;\n  }\n\n  .chatbot-wrapper.minimized      {                 /* collapsed look */\n  width : 52px;  height : 52px;  border-radius:50%;\n  position:fixed; right:30px; bottom:30px;\n  overflow:hidden; cursor:pointer;\n  box-shadow:0 0 6px rgba(0,0,0,.25);\n}\n\n.chatbot-wrapper.minimized .react-chatbot-kit-chat-container {\n  display:none !important;                       /* ← hides the UI */\n}\n    \n  .chatbot-wrapper {\n    position: fixed;\n    right: 0;\n    bottom: 0;\n    z-index: 9999;\n    height: 80%;\n    width: 30%;\n    margin: 15px;\n    border-radius: 5px;\n  }\n\n/* on phones: take the full page */\n@media (max-width: 768px){\n  .chatbot-wrapper{\n    left:0;\n    right:0;\n    top:0;\n    bottom:0;\n    width:100%;\n    height:100%;\n    margin:0;\n    border-radius:0;\n  }\n}\n\n\n  .react-chatbot-kit-chat-container {\n    position: fixed;\n    right: 5px;\n    bottom: 5px;\n    z-index: 1200;\n    height: 80%;\n    width: 30%;\n    border-style: solid;\n    border-width: 0px;\n    border-color: transparent;\n    margin: 15px;\n    border-radius: 5px;\n    box-shadow: 0 4px 4px 0 rgba(30,30,30,0.65), 0 2px 4px 0 rgba(0,0,0,0.25);\n  }\n\n  .react-chatbot-kit-chat-container {\n      transition: height 0.4s cubic-bezier(0.4, 0, 0.2, 1), \n                  width 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n      /* Optionally, add 'overflow: hidden;' to avoid visual glitches */\n  }\n\n@media (max-width: 768px){\n  .react-chatbot-kit-chat-container{\n    position: fixed;   /* keep it fixed so header stays at top */\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: 100% !important;\n    height: 100% !important;\n    margin: 0;         /* no side gaps */\n    border-radius: 0;  /* square corners like the wrapper */\n  }\n}\n\n  .react-chatbot-kit-chat-inner-container {\n    border-radius: 5px;\n    height: 100%;\n  }\n\n  .react-chatbot-kit-chat-message-container.moved-to-bottom {\n     height: 75% !important;\n  }\n\n  .react-chatbot-kit-chat-message-container {\n    border-radius: 5px;\n    height: 100%;\n    padding: 0 25.5px 10px 25.5px !important;\n  }\n\n\n\n\n  /* Force all chat messages to align left */\n.react-chatbot-kit-chat-message-container {\n  justify-content: flex-start !important;\n}\n\n/* Also remove right margins and force bubble positioning */\n.react-chatbot-kit-chat-bot-message {\n  margin-left: 0 !important;\n  margin-right: auto !important;\n  /* Optionally, make all user bubbles look like bot bubbles: */\n  background-color: #fff !important;   /* Set your preferred bubble color */\n  color: #000 !important;              /* Set your preferred text color */\n}\n\n.react-chatbot-kit-user-chat-message {\n  margin-left: 0 !important;\n  xmargin-right: auto !important;\n  /* Optionally, make all user bubbles look like bot bubbles: */\n  background-color: #91DDCA88 !important;   /* Set your preferred bubble color */\n  color: black !important;              /* Set your preferred text color */\n  border-radius: 10px;\n\n}\n\n.react-chatbot-kit-chat-bot-message-arrow {\n  display: none !important;\n}\n\n.react-chatbot-kit-user-chat-message-arrow {\n  display: none !important;\n}\n\n\n.react-chatbot-kit-chat-bot-message {\n    width: 100%;\n    text-align: left;\n    font-size: 1.1em;\n}\n\n.react-chatbot-kit-chat-user-message {\n    width: 100%;\n    text-align: center;\n    background-color: lightgray !important;\n    border-radius: 5px;\n}\n\n\n.react-chatbot-kit-chat-btn-send {\n  background-color: transparent !important;\n  height: 0;\n  width: 0;\n  display: none;\n\n}\n\n.react-chatbot-kit-chat-input-container {\n  \n   top: clamp(120px, 12%, 45%);\n  bottom: auto;\n  height: 95px;\n  width: 94%;\n  left: 3%;\n  text-align: center;\n  background-color: #efecec !important;\n  border-radius: 10px;\n  border: 1px lightgray solid;\n  transition: top 0.4s, bottom 0.4s; /* Optional for smooth movement */\n  padding-right: 52px;          /* room for the arrow  */\n  box-sizing: border-box;       /* <— THIS line        */\n}\n\n\n\n\n.react-chatbot-kit-chat-input {\n  background-color: #efecec !important;\n  height: 65px;\n  border-radius: 5px;\n  font-family: Roboto !important;\n  border: 0px !important;\n  resize: none;\n  outline: none !important; /* add this */\n  box-shadow: none !important; /* add this */\n  padding: 0px;\n  padding-left: 15px !important;\n  padding-right: 15px !important;\n  padding-top: 0px !important;\n  font-size: 1.1em !important;\n}\n\n.react-chatbot-kit-chat-input:focus {\n  outline: none !important;\n  box-shadow: none !important;\n  border-color: transparent !important;\n}\n\n.react-chatbot-kit-file-icon {\n  display: none !important;\n}\n\n.microphone-audio-wrapper {\n  background-color: transparent !important;\n  display: none;\n}\n\n.react-chatbot-kit-chat-input-form {\n  border-top: 0px !important;\n}\n\n/* green arrow – always inside the row */\n.chatbot-send-button{\n  position: fixed;             \n  color: #00A887;\n  cursor: pointer;\n  right : calc(3% + 12px) !important; \n   bottom:auto;\n  visibility:hidden;     \n  z-index: 10001;  \n}\n\n\n.chatbot-mic-button {\n  display: none !important;\n}\n\n.chatbot-mic-button.moved-to-bottom {\n  top: auto !important;\n  bottom: 40px !important; /* Or 0; */\n}\n\n.react-chatbot-kit-user-avatar-container {\n  display: none !important;  \n}\n\n/* element that wraps the HTML coming from the bot */\n.custom-html-message {\n  transform   : translateY(15px);\n  animation   : fadeInUp .5s forwards;\n  line-height : .51;                  /* default text line-height  */\n}\n\n/* ---- unordered & ordered lists ----------------------------------- */\n.custom-html-message ul,\n.custom-html-message ol {\n  /* A bit of air before the first bullet/number */\n  margin-top   : 0em;               /* ← space ABOVE the list    */\n  margin-bottom: 0em;               /*   space BELOW (optional)  */\n  margin-left  : 1.2em;               /* indent the whole list     */\n  padding-left : 0;                   /* keep bullets aligned      */\n}\n\n.custom-html-message ul  { list-style: disc    outside; }\n.custom-html-message ol  { list-style: decimal outside; }\n\n/* ---- individual list items --------------------------------------- */\n.custom-html-message li {\n  margin-top   : 0em;              /* vertical spacing BETWEEN bullets */\n  margin-bottom: 0em;              /* (adjust to taste)                */\n}\n/* tighter vertical space after explicit <br> tags */\n.custom-html-message br {\n  line-height : 0.2em;      /* 40 % of a normal line  – tweak to taste */\n  /* you can also use margin if you prefer */\n   margin-top : -0.3em;   margin-bottom : 0.3em; \n}\n\n\n.react-chatbot-kit-chat-input-container.moved-to-bottom {\n  top: auto !important;\n  bottom: 5% !important; /* Or 0; */\n}\n\n.chatbot-send-button.moved-to-bottom {\n  //bottom: 40px !important;\n    right : calc(3% ) !important; \n   position:fixed !important;   /* switch from absolute → fixed   */\n    bottom: calc(5% + 15px)  !important;      /* 20 px up from the bottom edge  */\n    top   :auto   !important;     /* neutralise any inline “top:”   */\n    left  :auto   !important;     /* neutralise any inline “left:”  */\n    z-index:10002;               /* keep it above the chat window  */\n}\n\n/* phones: attach the green arrow to the SCREEN, not the wrapper */\n@media (max-width:768px){\n  .chatbot-send-button.moved-to-bottom{\n    position:fixed !important;   /* switch from absolute → fixed   */\n    bottom:55px  !important;      /* 20 px up from the bottom edge  */\n    right :30px  !important;      /* (tweak if you want 12 px etc.) */\n    top   :auto   !important;     /* neutralise any inline “top:”   */\n    left  :auto   !important;     /* neutralise any inline “left:”  */\n    z-index:10002;               /* keep it above the chat window  */\n  }\n}\n\n\n/* helper line at the very bottom, centre-aligned, light grey */\n.chatbot-reset-hint{\n  position:absolute;          /* relative to .chatbot-wrapper      */\n  bottom:5px;                 /* 4 px above the wrapper’s bottom   */\n  left:0;\n  width:100%;\n  text-align:center;\n  font-size:14px;\n  font-style: italic;\n  color:#9e9e9e;              /* light grey                        */\n  pointer-events:none;        /* clicks pass through               */\n  z-index: 10002\n}\n\n.chatbot-reset-hint-small{\n  position:absolute;          /* relative to .chatbot-wrapper      */\n  bottom:7px;                 /* 4 px above the wrapper’s bottom   */\n  left:0;\n  width:100%;\n  text-align:center;\n  font-size:12px;\n  font-style: italic;\n  color:#9e9e9e;              /* light grey                        */\n  pointer-events:none;        /* clicks pass through               */\n  z-index: 10002\n}\n\n@media (max-width:768px){\n    .chatbot-reset-hint-small{\n    position:fixed;          /* relative to .chatbot-wrapper      */\n    bottom:0px;                 /* 4 px above the wrapper’s bottom   */\n    left:0;\n    width:100%;\n    text-align:center;\n    font-size:12px;\n    font-style: italic;\n    color:#9e9e9e;              /* light grey                        */\n    pointer-events:none;        /* clicks pass through               */\n    z-index: 10002\n  } \n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
